import script from "./SetupLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupLinks.vue?vue&type=script&setup=true&lang=js"

import "./SetupLinks.vue?vue&type=style&index=0&id=ac7d2e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac7d2e4e"]])

export default __exports__